import React from 'react'
import { Grid, Avatar } from '@mui/material'
import PropTypes from 'prop-types'
import EvanPic from 'components/assets/evan.png'
import GordonPic from 'components/assets/gordon.png'
import { WhiteTextTypography, WhiteTextTypographyLeft } from './Typography'

const TEAM = [
  { imageUrl: GordonPic, name: 'Gordon Driscoll', title: 'Co-founder and CEO' },
  { imageUrl: EvanPic, name: 'Evan Vandegriff', title: 'Co-founder and CTO' },
]

const HeadShot = ({ person }) => (
  <Grid item direction="column" alignItems="center" justifyContent="center">
    <Avatar alt={person?.name} src={person?.imageUrl} sx={{ width: 200, height: 200 }} />
    <WhiteTextTypography mt={1} sx={{ textDecoration: 'underline' }} gutterBottom>
      {person?.name}
    </WhiteTextTypography>
    <WhiteTextTypography gutterBottom>{person?.title}</WhiteTextTypography>
  </Grid>
)

HeadShot.propTypes = {
  person: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

const AboutUs = () => (
  <Grid item>
    <WhiteTextTypography gutterBottom variant="h2">
      ABOUT US
    </WhiteTextTypography>

    <WhiteTextTypography gutterBottom>
      Despite the importance of metal recycling, the industry’s software development has not kept up with an
      increasingly modern world. This is why we started GreenSpark in March 2021 - to bring the metal recycling industry
      into the 21st century by modernizing and digitizing its most important processes. We’re a team of founders and
      developers building tools to improve the metal recycling industry.
    </WhiteTextTypography>

    <WhiteTextTypography mt={3} mb={5} gutterBottom>
      GreenSpark intends to follow the metal in a scrap yard, from point of purchase all the way to the ultimate sale,
      with everything that those processes entail, all under one roof. By connecting the scrap yard’s operation through
      the metal’s life cycle, we increase our customers’ access to data, save them time and money, and meaningfully
      improve their overall experience
    </WhiteTextTypography>

    <WhiteTextTypography gutterBottom variant="h2">
      Our Values
    </WhiteTextTypography>

    <WhiteTextTypographyLeft variant="h4">Partners, Not Salesmen</WhiteTextTypographyLeft>

    <WhiteTextTypographyLeft mb={3} gutterBottom>
      We’re trusted, long-term partners for our industry. We value the needs of our customers and seek to understand
      their points of view when solving problems. We’re gracious and enthusiastic members of our community.
    </WhiteTextTypographyLeft>

    <WhiteTextTypographyLeft variant="h4">Be Humble and Adapt</WhiteTextTypographyLeft>

    <WhiteTextTypographyLeft mb={3} gutterBottom>
      There are no shortcuts when building relationships, technology, and a business. We know that the path to success
      includes challenges -- we embrace those challenges and learn from them.
    </WhiteTextTypographyLeft>

    <WhiteTextTypographyLeft variant="h4">Build Bigger</WhiteTextTypographyLeft>

    <WhiteTextTypographyLeft gutterBottom>
      We look for 10x better, not 10%. We push the status quo of the industry to deliver more value for our customers,
      investors and team members
    </WhiteTextTypographyLeft>

    <WhiteTextTypography mt={6} mb={6} variant="h2">
      The Founding Team
    </WhiteTextTypography>

    <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
      <Grid container justifyContent="space-around">
        {TEAM.map(person => (
          <HeadShot person={person} />
        ))}
      </Grid>
    </Grid>
  </Grid>
)

export default AboutUs
